var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { utilFps } from "../../utils/utilFps";
import { appCanvas } from "../app/appCanvas";
var HudFPSDisplayDOM = /** @class */ (function (_super) {
    __extends(HudFPSDisplayDOM, _super);
    function HudFPSDisplayDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.timerId = -1;
        _this.isRunning = false;
        _this.state = {
            fps: 0,
            fpsStyle: "low",
        };
        return _this;
    }
    HudFPSDisplayDOM.prototype.render = function () {
        if (!this.props.isFPSDisplayVisible) {
            if (this.isRunning) {
                this.clearUpdate();
            }
            return React.createElement(React.Fragment, null);
        }
        if (!this.isRunning) {
            this.startUpdate();
        }
        return (React.createElement("div", { className: "flex flex--guts cheat-fps cheat-fps__" + this.state.fpsStyle }, this.state.fps + " FPS",
            " ",
            React.createElement("br", null), Math.round(appCanvas.ticker.FPS) + " App FPS",
            " ",
            React.createElement("br", null)));
    };
    HudFPSDisplayDOM.prototype.clearUpdate = function () {
        if (this.timerId > -1) {
            clearInterval(this.timerId);
            this.timerId = -1;
        }
        this.isRunning = false;
    };
    HudFPSDisplayDOM.prototype.startUpdate = function () {
        var _this = this;
        this.timerId = setInterval(function () {
            var fps = utilFps.getFps();
            var fpsStyle = "low";
            if (fps >= 45) {
                fpsStyle = "high";
            }
            else if (fps >= 25) {
                fpsStyle = "med";
            }
            _this.setState({ fps: fps, fpsStyle: fpsStyle });
        }, 1000);
        this.isRunning = true;
    };
    return HudFPSDisplayDOM;
}(React.Component));
var mapState = function (state) { return ({
    isFPSDisplayVisible: state.cheats.isFPSDisplayVisible,
}); };
export var HudFPSDisplay = connect(mapState)(HudFPSDisplayDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/fps-display/HudFPSDisplay.tsx
// module id = 2303
// module chunks = 3